import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrow3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M18.412 5.58a1.951 1.951 0 0 0-2.777 0l-1.248 1.268 2.756 2.757 1.249-1.248a1.951 1.951 0 0 0 .02-2.777Zm-4.949 2.192-5.455 5.455a.748.748 0 0 0-.124.17l-1.808 3.647a.65.65 0 0 0 .566.956.65.65 0 0 0 .286-.065l3.648-1.808a.75.75 0 0 0 .17-.123l5.455-5.456-2.738-2.776ZM12.494 18h5.852a.65.65 0 1 0 0-1.3h-5.852a.65.65 0 0 0 0 1.3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrow3;
